export default __webpack_public_path__ + "static/media/README.b21c45b4.md";